import { Code, Database, Cloud, BookOpen, Server, Users, Terminal, Facebook, Twitter, Linkedin } from "lucide-react";

// Mock data for Syed Bakhtawar Fahim's Portfolio
export const profileData = {
  name: "Syed Bakhtawar Fahim",
  title: "Software & Data Engineer",
  bio: "Certified Data Engineer from Karachi AI Community and Full Stack Developer with 5+ years of experience in building scalable web applications and advanced data solutions.",
  email: "contact@syedbakhtawarfahim.dev",
  phone: "+92-332-9381910",
  location: "Karachi, Pakistan",
  // profileImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
  // profileImage: "https://res.cloudinary.com/dxn7uoj80/image/upload/v1755605869/WhatsApp_Image_2025-08-19_at_17.11.49_7af305a1_qv3iqv.jpg",
  // profileImage: "https://res.cloudinary.com/dxn7uoj80/image/upload/v1755606364/sda_ncbcze.jpg",
  profileImage: "https://res.cloudinary.com/dxn7uoj80/image/upload/v1755858250/linkedin_-_Copy_g4z76g.png",
  // profileImage: "https://res.cloudinary.com/dxn7uoj80/image/upload/v1755857965/linkedin_qtz1aq.png",
  social: {
    linkedin: "https://www.linkedin.com/in/syedbakhtawarfahim/",
    github: "https://github.com/Syed-Bakhtawar-Fahim",
    medium: "https://medium.com/@bakhtawarfahim10",
    twitter: "https://twitter.com/bakhtawarfahim"
  }
};

export const experiences = [
  {
    id: 1,
    company: "Regtify",
    role: "Senior Software Engineer",
    duration: "12/2024 – Present",
    location: "Karachi, Pakistan",
    type: "Full-time",
    description: "Working on fintech products Dora/CMRS and IFR, delivering scalable and secure solutions for the financial services sector.",
    technologies: ["Node.js", "Express.js", "WebSockets", "AWS Elastic Beanstalk", "Cron Jobs", "xBRL", "CYSEC"],
    achievements: [
      "Worked on fintech products Dora/CMRS and IFR, delivering scalable and secure solutions tailored for the financial services sector",
      "Designed, developed, and optimized backend architecture aligned with ISO compliance standards",
      "Implemented GLEIF API integration for automated Legal Entity Identifier (LEI) registration and updates",
      "Developed and scheduled cron jobs for background tasks and recurring operations",
      "Worked with WebSockets for real-time communication, data transmission, and event-driven updates",
      "Built a notification system for real-time user alerts and system events",
      "Generated xBRL and CYSEC reports along with other regulatory reporting files, ensuring strict adherence to financial compliance standards",
      "Deployed and maintained backend services using AWS Elastic Beanstalk to ensure high availability and performance",
      "Reported directly to the CEO, providing strategic technical insights and aligning development efforts with business goals"
    ]
  },
  {
    id: 2,
    company: "Techxudo",
    role: "Senior Software Engineer",
    duration: "09/2023 – 12/2024",
    location: "Karachi, Pakistan",
    type: "Full-time",
    description: "Architected and implemented RESTful APIs, led a team of engineers, and delivered B2B and B2C flight operation applications.",
    technologies: ["Node.js", "Express.js", "React.js", "Next.js", "AWS", "Docker", "PostgreSQL", "MongoDB"],
    achievements: [
      "Architected and implemented RESTful APIs for seamless frontend-backend communication",
      "Worked with layered architecture and repository patterns to maintain clean and modular codebases",
      "Developed and maintained B2B and B2C flight operation applications with robust business logic",
      "Led and managed a team of 6 engineers, overseeing sprint planning, code reviews, and mentorship",
      "Created ERDs and architected efficient database schemas for relational and NoSQL databases",
      "Leveraged AWS cloud services for application deployment, storage, and environment provisioning",
      "Implemented security features such as input validation, authentication, authorization, and data encryption",
      "Applied rate limiting and abuse prevention techniques across public-facing APIs",
      "Implemented caching strategies to improve performance and scalability",
      "Dockerized applications for environment consistency and deployed them to AWS EC2 instances",
      "Designed full system architecture and provided technical leadership across multiple projects",
      "Implemented caching and query optimization techniques to improve API response time"
    ]
  },
  {
    id: 3,
    company: "Techxudo",
    role: "Software Engineer II",
    duration: "03/2023 – 09/2023",
    location: "Karachi, Pakistan",
    type: "Full-time",
    description: "Designed and developed scalable backend APIs and integrated third-party payment gateways.",
    technologies: ["Node.js", "Express.js", "React.js", "Next.js", "MongoDB", "Payment Gateways"],
    achievements: [
      "Designed and developed scalable backend APIs using Node.js and Express",
      "Integrated third-party payment gateways for end-to-end transaction workflows",
      "Designed and integrated user-facing elements developed in ReactJS/NextJS with server-side logic",
      "Architected and optimized database schemas and queries for efficient data storage and retrieval",
      "Designed and implemented multilingual web applications with full localization and internationalization support"
    ]
  },
  {
    id: 4,
    company: "Xnitia",
    role: "Data Engineer",
    duration: "01/2024 – 06/2024",
    location: "Remote",
    type: "Contract",
    description: "Handled large-scale data processing using PySpark, AWS Lambda, and other AWS services.",
    technologies: ["AWS", "PySpark", "DynamoDB", "S3", "EC2", "Flask", "Node.js", "EMR", "Step Functions"],
    achievements: [
      "Processed around 1 million records from over 50K users using PySpark and AWS services",
      "Handled frontend with Next.js, CSV file processing with S3, and backend services on EC2 with Flask and Node.js",
      "Implemented Lambda functions to retrieve data from DynamoDB and pass it to AWS EMR for advanced data processing",
      "Designed and delivered effective pipelines for large-scale data analytics"
    ]
  },
  {
    id: 5,
    company: "Ecom-Professional",
    role: "Software Engineer",
    duration: "03/2022 – 01/2023",
    location: "Karachi, Pakistan",
    type: "Full-time",
    description: "Developed and maintained web applications using the MERN stack, built RESTful APIs, and collaborated on features.",
    technologies: ["MongoDB", "Express.js", "React.js", "Node.js", "REST APIs"],
    achievements: [
      "Designed, developed, and maintained web applications using the MERN stack",
      "Built RESTful APIs and ensured secure, reliable backend services",
      "Collaborated with developers to plan and develop application features",
      "Ensured applications met all security requirements"
    ]
  },
  {
    id: 6,
    company: "Group of Freelancer",
    role: "MERN Stack Intern",
    duration: "12/2021 – 02/2022",
    location: "Remote",
    type: "Internship",
    description: "Started career as a MERN Stack Intern, developing front-end applications and converting Figma designs to ReactJS.",
    technologies: ["MongoDB", "Express.js", "React.js", "Node.js"],
    achievements: [
      "Wrote reusable, testable, and efficient front-end code",
      "Converted Figma designs into ReactJS applications",
      "Gained hands-on experience with the MERN stack"
    ]
  },
  {
    id: 7,
    company: "JPMorgan",
    role: "Software Engineering Virtual Experience",
    duration: "2022 – 2023",
    location: "Remote",
    type: "Virtual Internship",
    description: "Interacted with stock price data feed and implemented visualizations for traders.",
    technologies: ["Charts", "Graphs", "Data Visualization", "Python", "Pandas"],
    achievements: [
      "Interacted with stock price data feed and visualized it for traders",
      "Implemented charts, graphs, and other visual elements to present key insights and trends"
    ]
  },
  {
    id: 8,
    company: "Walmart",
    role: "Advanced Software Engineering",
    duration: "2022 – 2023",
    location: "Remote",
    type: "Virtual Internship",
    description: "Learned MVC architecture, SQL, MySQL, and data visualization for structured and unstructured data.",
    technologies: ["SQL", "MySQL", "Pandas", "MVC"],
    achievements: [
      "Gained experience with MVC architectural patterns",
      "Handled structured and unstructured data effectively",
      "Used data visualization tools to extract insights from various data sources"
    ]
  }
];



export const projects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    description: "Full-stack e-commerce solution with payment integration, inventory management, and admin dashboard.",
    category: "Web Application",
    technologies: ["React", "Node.js", "MongoDB", "Stripe", "AWS"],
    images: [
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop"
    ],
    liveUrl: "https://ecommerce-demo.com",
    githubUrl: "https://github.com/bakhtawarfahim/ecommerce-platform",
    featured: true,
    status: "Completed"
  },
  {
    id: 2,
    title: "Task Management App",
    description: "Mobile-first task management application with real-time collaboration and notifications.",
    category: "Mobile App",
    technologies: ["React Native", "Firebase", "Redux", "Push Notifications"],
    images: [
      "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop"
    ],
    liveUrl: "https://taskapp-demo.com",
    githubUrl: "https://github.com/bakhtawarfahim/task-manager",
    featured: true,
    status: "Completed"
  },
  {
    id: 3,
    title: "Microservices Architecture",
    description: "Scalable microservices system design for high-traffic applications with load balancing and caching.",
    category: "System Design",
    technologies: ["Docker", "Kubernetes", "Redis", "NGINX", "PostgreSQL"],
    images: [
      "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=800&h=600&fit=crop"
    ],
    liveUrl: null,
    githubUrl: "https://github.com/bakhtawarfahim/microservices-design",
    featured: false,
    status: "Completed"
  },
  {
    id: 4,
    title: "CI/CD Pipeline Setup",
    description: "Automated deployment pipeline with testing, security scanning, and monitoring for multiple environments.",
    category: "DevOps",
    technologies: ["Jenkins", "Docker", "AWS", "Terraform", "Monitoring"],
    images: [
      "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1605379399642-870262d3d051?w=800&h=600&fit=crop"
    ],
    liveUrl: null,
    githubUrl: "https://github.com/bakhtawarfahim/cicd-pipeline",
    featured: false,
    status: "Completed"
  },
  {
    id: 5,
    title: "Data Analytics Dashboard",
    description: "Real-time analytics dashboard with interactive visualizations and automated reporting.",
    category: "Web Application",
    technologies: ["React", "D3.js", "Python", "FastAPI", "PostgreSQL"],
    images: [
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop"
    ],
    liveUrl: "https://analytics-demo.com",
    githubUrl: "https://github.com/bakhtawarfahim/analytics-dashboard",
    featured: true,
    status: "In Progress"
  }
];

export const blogs = [
  {
    id: 1,
    title: "Building Scalable Web Applications with MERN Stack",
    excerpt: "Learn how to build and deploy scalable web applications using MongoDB, Express.js, React, and Node.js with best practices.",
    content: "Full blog content here...",
    publishedAt: "2024-01-15",
    readTime: "8 min read",
    tags: ["React", "Node.js", "MongoDB", "Web Development"],
    image: "https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=800&h=400&fit=crop",
    url: "https://medium.com/@bakhtawarfahim10/building-scalable-web-applications",
    featured: true
  },
  {
    id: 2,
    title: "Data Engineering Best Practices with AWS",
    excerpt: "Essential patterns and practices for building robust data pipelines using AWS services like S3, Lambda, and Kinesis.",
    content: "Full blog content here...",
    publishedAt: "2024-01-10",
    readTime: "12 min read",
    tags: ["AWS", "Data Engineering", "PySpark", "Big Data"],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=400&fit=crop",
    url: "https://medium.com/@bakhtawarfahim10/data-engineering-aws",
    featured: true
  },
  {
    id: 3,
    title: "Advanced React Patterns and Performance Optimization",
    excerpt: "Deep dive into advanced React patterns, performance optimization techniques, and best practices for large applications.",
    content: "Full blog content here...",
    publishedAt: "2024-01-05",
    readTime: "10 min read",
    tags: ["React", "Performance", "JavaScript", "Frontend"],
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=400&fit=crop",
    url: "https://medium.com/@bakhtawarfahim10/advanced-react-patterns",
    featured: false
  }
];

export const skills = [
  {
    category: "Programming Languages ",
    technologies: ["JavaScript", "TypeScript", "Python"]
  },
  {
    category: "Frontend Development",
    technologies: ["ReactJS", "NextJS", "TypeScript", "Tailwind CSS", "Redux"]
  },
  {
    category: "Backend Development",
    technologies: ["NodeJS", "ExpressJS", "NestJS", "Python", "Flask"]
  },
  {
    category: "Databases & ORM",
    technologies: ["PostgreSQL", "MongoDB", "MySQL", "Sequelize", "TypeORM", "Mongoose", "Sequelize", "Prisma", "DynamoDB"]
  },
  {
    category: "Data Engineering",
    technologies: ["Apache Spark", "PySpark", "Apache Kafka", "Elasticsearch", "ETL Pipelines", "Data Warehousing", "Pandas", "Numpy", "Matplotlib", "BeautifullSoup"]
  },
  {
    category: "Cloud & DevOps",
    technologies: ["AWS", "Docker", "Kubernetes", "Jenkins", "Terraform", "CI/CD Pipelines", "Github Actions", "Netlify", "Heroku"]
  },
  {
    category: "Mobile Development",
    technologies: ["React Native", "iOS", "Android"]
  },
  {
    category: "Version Controls & Tools",
    technologies: ["Github", "Git", "BitBucket", "Swagger", "Postman", "Redis", "NGINX", "PM2", "Jira", "Confluence", "VS Code", "Figma", "Slack", "Notion"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmad Hassan",
    role: "CTO at Regtify",
    company: "Regtify",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
    text: "Bakhtawar is an exceptional developer who consistently delivers high-quality solutions. His expertise in full-stack development has been invaluable to our fintech platform."
  },
  {
    id: 2,
    name: "Sarah Ahmed",
    role: "Lead Data Engineer",
    company: "Xnitia",
    image: "https://images.unsplash.com/photo-1494790108755-2616b332c2e1?w=100&h=100&fit=crop&crop=face",
    text: "Working with Bakhtawar on data engineering projects was a great experience. His knowledge of AWS and PySpark helped us build robust data pipelines."
  }
];

export const categories = ["All", "Web Application", "Mobile App", "System Design", "DevOps"];

export const journey = [
  {
    year: '12/2021 – 02/2022',
    title: 'MERN Stack Intern',
    description: `Started career as a MERN Stack Intern, writing reusable and testable code, 
  developing front-end web applications, and converting Figma designs to ReactJS.`,
    icon: Code
  },
  {
    year: '03/2022 – 01/2023',
    title: 'Software Engineer, Ecom-Professional',
    description: `Joined Ecom-Professional as Software Engineer, developing and maintaining secure web applications, 
  building RESTful APIs, and collaborating with developers to implement application features.`,
    icon: Code
  },
  {
    year: '2022 - 2024',
    title: 'Data Engineer, Xnitia',
    description: `Handled large-scale data using PySpark, AWS (S3, Lambda, EMR, Step Functions), 
    built pipelines and serverless backend solutions, and delivered products effectively to clients.`,
    icon: Database
  },
  {
    year: '2023 - 2024',
    title: 'Software Engineer / Senior Software Engineer, Techxudo',
    description: `Developed scalable B2B/B2C applications, designed RESTful APIs, implemented caching strategies, 
    optimized database queries, led a team of 6 engineers, and deployed applications on AWS.`,
    icon: Cloud
  },
  {
    year: '12/2024 – present',
    title: 'Senior Software Engineer, Regtify',
    description: `Working on fintech products Dora/CMRS and IFR, implementing ISO-compliant backend architecture, 
    GLEIF API integration, WebSockets for real-time updates, xBRL & CYSEC regulatory reporting, 
    AWS Elastic Beanstalk deployment, and reporting directly to the CEO.`,
    icon: Server
  },
  {
    year: '2022 - 2023',
    title: 'Software Engineering Virtual Experience & Advanced Learning',
    description: `Participated in virtual experiences from JPMorgan and Walmart, 
    visualized stock price data, explored MVC architecture, and worked with SQL, MySQL, Pandas, 
    and advanced data visualization techniques.`,
    icon: BookOpen
  },
  {
    year: '2025',
    title: 'Continuous Learning & Mentorship',
    description: `Currently expanding expertise in advanced backend development, NestJS, and cloud infrastructure, 
    while sharing knowledge through blogging, mentoring, and real-world project delivery.`,
    icon: Users
  }
];

const baseCountryColors = {
  USA: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',          // Red/Blue/White
  UK: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',              // Red/Blue/White
  Cyprus: 'bg-purple-100 text-purple-800 dark:bg-purple-900/20 dark:text-purple-300', // White/Orange/Green
  Spain: 'bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-300',  // Red/Yellow
  Canada: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',          // Red/White
  Australia: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',   // Blue/White/Red
  Pakistan: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',// Green/White
  France: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',      // Blue/White/Red
  Germany: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300', // Black/Red/Yellow
  Italy: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',   // Green/White/Red
  India: 'bg-orange-100 text-orange-800 dark:bg-orange-900/20 dark:text-orange-300', // Orange/Green/White
  China: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',           // Red/Yellow
  Japan: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',           // Red/White
  Brazil: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',  // Green/Yellow/Blue
  Mexico: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',  // Green/White/Red
  Russia: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',      // White/Blue/Red
  SouthAfrica: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300', // Green/Yellow/Black
  SaudiArabia: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300', // Green/White
  Turkey: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',          // Red/White
  UAE: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',     // Red/Green/Black/White
  Argentina: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',   // Blue/White
  Bangladesh: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300', // Green/Red
  Egypt: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',           // Red/White/Black
  Indonesia: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',       // Red/White
  Malaysia: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',    // Blue/Red/Yellow
  Thailand: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',        // Red/Blue/White
  Vietnam: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',         // Red/Yellow
  Nigeria: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300', // Green/White
  Kenya: 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300',           // Red/Green/Black
  SouthKorea: 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300',  // White/Red/Blue
  Dubai: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',
  Portugal: 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300',
};


const generateColors = (baseColors) => {
  const result = {};
  Object.entries(baseColors).forEach(([country, color]) => {
    result[country] = color;
    result[`${country} Client`] = color;
  });
  return result;
};

const colors = generateColors(baseCountryColors);

export const getTagColor = (tag) => {
  return colors[tag] || 'bg-gray-100 text-gray-800 dark:bg-gray-900/20 dark:text-gray-300';
};
